import type { LabeledFilterCondition } from './filterCondition'
import { FilterCondition } from './filterCondition'
import { FieldType } from '@wix/wix-data-schema-types'
const {
  boolean,
  text,
  number,
  reference,
  multiReference,
  audio,
  dateTime,
  date,
  document,
  image,
  mediaGallery,
  richText,
  time,
  url,
  video,
  address,
  stringArray,
} = FieldType

const supportedConditions = {
  [text]: [
    {
      value: FilterCondition.EQUALS,
      label: 'Datatype_Text_Condition_Is',
    },
    {
      value: FilterCondition.NOT_EQUALS,
      label: 'Datatype_Text_Condition_IsNot',
    },
    {
      value: FilterCondition.CONTAINS,
      label: 'Datatype_Text_Condition_Contains',
    },
    {
      value: FilterCondition.NOT_CONTAINS,
      label: 'Datatype_Text_Condition_DoesNotContain',
    },
    {
      value: FilterCondition.STARTS_WITH,
      label: 'Datatype_Text_Condition_StartsWith',
    },
    {
      value: FilterCondition.ENDS_WITH,
      label: 'Datatype_Text_Condition_EndsWith',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],

  [boolean]: [
    {
      value: FilterCondition.EQUALS,
      label: 'Datatype_Boolean_Condition_Is',
    },
    {
      value: FilterCondition.NOT_EQUALS,
      label: 'Datatype_Boolean_Condition_IsNot',
    },
  ],

  [number]: [
    {
      value: FilterCondition.EQUALS,
      label: 'Datatype_Number_Condition_Equals',
    },
    {
      value: FilterCondition.NOT_EQUALS,
      label: 'Datatype_Number_Condition_DoesNotEqual',
    },
    {
      value: FilterCondition.GREATER_THAN_OR_EQUAL,
      label: 'Datatype_Number_Condition_GreaterThanOrEqual',
    },
    {
      value: FilterCondition.LESS_THAN_OR_EQUAL,
      label: 'Datatype_Number_Condition_LessThanOrEqual',
    },
    {
      value: FilterCondition.GREATER_THAN,
      label: 'Datatype_Number_Condition_GreaterThan',
    },
    {
      value: FilterCondition.LESS_THAN,
      label: 'Datatype_Number_Condition_LessThan',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],

  [reference]: [
    {
      value: FilterCondition.EQUALS,
      label: 'Datatype_Reference_Condition_SameAs',
    },
    {
      value: FilterCondition.NOT_EQUALS,
      label: 'Datatype_Reference_Condition_IsNot',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],

  [multiReference]: [
    {
      value: FilterCondition.INCLUDES_ANY,
      label: 'Datatype_MultiRef_Condition_Includes',
    },
    {
      value: FilterCondition.EXCLUDES_ALL,
      label: 'Datatype_MultiRef_Condition_Excludes',
    },
  ],
  [audio]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [dateTime]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [date]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [document]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [image]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [mediaGallery]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [richText]: [
    {
      value: FilterCondition.CONTAINS,
      label: 'Datatype_RichText_Condition_Contains',
    },
    {
      value: FilterCondition.NOT_CONTAINS,
      label: 'Datatype_RichText_Condition_DoesNotContain',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [time]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [url]: [
    {
      value: FilterCondition.EQUALS,
      label: 'Datatype_URL_Condition_Is',
    },
    {
      value: FilterCondition.NOT_EQUALS,
      label: 'Datatype_URL_Condition_IsNot',
    },
    {
      value: FilterCondition.CONTAINS,
      label: 'Datatype_URL_Condition_Contains',
    },
    {
      value: FilterCondition.NOT_CONTAINS,
      label: 'Datatype_URL_Condition_DoesNotContain',
    },
    {
      value: FilterCondition.STARTS_WITH,
      label: 'Datatype_URL_Condition_StartsWith',
    },
    {
      value: FilterCondition.ENDS_WITH,
      label: 'Datatype_URL_Condition_EndsWith',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
  [video]: [
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],

  [address]: [
    {
      value: FilterCondition.CONTAINS,
      label: 'Datatype_Address_Condition_Contains',
    },
    {
      value: FilterCondition.NOT_CONTAINS,
      label: 'Datatype_Address_Condition_DoesNotContain',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],

  [stringArray]: [
    {
      value: FilterCondition.INCLUDES_ANY,
      label: 'Datatype_StringArray_Condition_IncludesAny',
    },
    {
      value: FilterCondition.EXCLUDES_ANY,
      label: 'Datatype_StringArray_Condition_ExcludesAny',
    },
    {
      value: FilterCondition.INCLUDES_ALL,
      label: 'Datatype_StringArray_Condition_IncludesAll',
    },
    {
      value: FilterCondition.EXCLUDES_ALL,
      label: 'Datatype_StringArray_Condition_ExcludesAll',
    },
    {
      value: FilterCondition.IS_NOT_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isNotEmpty',
    },
    {
      value: FilterCondition.IS_EMPTY,
      label: 'Dataset_Settings_Add_Filter_Panel_Condition_isEmpty',
    },
  ],
} satisfies Partial<Record<FieldType, LabeledFilterCondition[]>>

export default supportedConditions
